import React from 'react';
import { useDispatch } from 'react-redux';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { addItemToCart } from '../../redux/slices/cartSlice';
import { toggleWishlistItem } from '../../redux/slices/wishlistSlice';
import { toggleCompareItem } from '../../redux/slices/compareSlice';
import SingleShop from '../../components/Shop';
import useProducts from '../../hooks/useProducts';

const ShopTwo = () => {
  const { products, status, error } = useProducts(); // Use the custom hook to fetch product data and manage loading/error states
  const dispatch = useDispatch();

  const featureProducts = products.slice(0, 4);
  const bestSaleProducts = products.slice(4, 8);
  const popularProducts = products.slice(8, 12);

  // Dispatch the action to add the item to cart
  const handleAddToCart = (product) => {
    dispatch(
      addItemToCart({
        product: product,
      })
    );
  };

  // Dispatch the action to toggle the item to the wishlist
  const handleToggleWishlist = (product) => {
    dispatch(toggleWishlistItem(product));
  };

  // Dispatch the action to toggle the item to the Compare
  const handleToggleCompare = (product) => {
    dispatch(toggleCompareItem(product));
  };

  // Tab names
  const tabNames = [
    { tabName: 'Featured' },
    { tabName: 'Best Sellers' },
    { tabName: 'Popular' },
  ];
  const tabStyle =
    'nav nav-tab justify-content-center justify-content-lg-start';

  // Render a loading message while the products are being fetched
  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  // Render an error message if the fetch request fails
  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="it-shop-area fix pb-90">
      <div className="container">
        <Tabs>
          <div className="it-shop-title-wrap mb-65">
            <div className="row">
              <div className="col-xl-12">
                <div className="it-shop-nav-box">
                  <TabList className={tabStyle}>
                    {tabNames.map((item, index) => (
                      <Tab key={index}>
                        <button>{item.tabName}</button>
                      </Tab>
                    ))}
                  </TabList>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="it-shop-slider-wrapper">
                <div className="tab-content" id="myTabContent">
                  <TabPanel className="row">
                    <div className="col-xl-12">
                      <div className="it-shop-tab-content">
                        <div className="row">
                          {featureProducts.map((product) => (
                            <div
                              key={product.id}
                              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30 "
                            >
                              <SingleShop
                                itemClass="it-shop-item p-relative item-fixed-height"
                                productId={product.id}
                                thumbnailImg={product.thumbnail}
                                badgeTitle={product.badgeTitle}
                                title={product.title}
                                price={product.price}
                                rating={product.rating}
                                category={product.category}
                                images={product.images}
                                inStock={product.inStock}
                                onAddToCart={() => handleAddToCart(product)}
                                onToggleWishlist={() =>
                                  handleToggleWishlist(product)
                                }
                                onToggleCompare={() =>
                                  handleToggleCompare(product)
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel className="row">
                    <div className="col-xl-12">
                      <div className="it-shop-tab-content">
                        <div className="row">
                          {bestSaleProducts.map((product) => (
                            <div
                              key={product.id}
                              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30 "
                            >
                              <SingleShop
                                itemClass="it-shop-item p-relative item-fixed-height"
                                productId={product.id}
                                thumbnailImg={product.thumbnail}
                                badgeTitle={product.badgeTitle}
                                title={product.title}
                                price={product.price}
                                rating={product.rating}
                                category={product.category}
                                images={product.images}
                                inStock={product.inStock}
                                onAddToCart={() => handleAddToCart(product)}
                                onToggleWishlist={() =>
                                  handleToggleWishlist(product)
                                }
                                onToggleCompare={() =>
                                  handleToggleCompare(product)
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </TabPanel>

                  <TabPanel className="row">
                    <div className="col-xl-12">
                      <div className="it-shop-tab-content">
                        <div className="row">
                          {popularProducts.map((product) => (
                            <div
                              key={product.id}
                              className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30"
                            >
                              <SingleShop
                                itemClass="it-shop-item p-relative item-fixed-height"
                                productId={product.id}
                                thumbnailImg={product.thumbnail}
                                badgeTitle={product.badgeTitle}
                                title={product.title}
                                price={product.price}
                                rating={product.rating}
                                category={product.category}
                                images={product.images}
                                inStock={product.inStock}
                                onAddToCart={() => handleAddToCart(product)}
                                onToggleWishlist={() =>
                                  handleToggleWishlist(product)
                                }
                                onToggleCompare={() =>
                                  handleToggleCompare(product)
                                }
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </div>
          </div>
        </Tabs>
      </div>
    </div>
  );
};

export default ShopTwo;
